export default __webpack_public_path__ + "static/media/close.458ef91f.svg";